module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fade modal",
    attrs: {
      "id": _vm.option.id,
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "choose-modal modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title text-left"
  }, [_vm._v("\n          " + _vm._s(_vm.option.title) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body text-left"
  }, [_c('div', {
    staticClass: "text-left"
  }, _vm._l((_vm.productList), function(elem) {
    return (elem.active) ? _c('button', {
      staticClass: "btn btn-choose-element btn-default",
      class: {
        'active': elem.item_id === _vm.curClick
      },
      on: {
        "click": function () { return _vm.clickElement(elem); }
      }
    }, [_vm._v("\n            " + _vm._s(elem.name)), _c('span', [_vm._v("  $" + _vm._s(_vm.getPrice(elem.price)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "text-remark"
    }, [_c('small', [_vm._v(" " + _vm._s(elem.remark) + " ")])])]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', [_c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productInfo.sort),
      expression: "productInfo.sort"
    }],
    ref: "sort",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.productInfo.sort)
    },
    on: {
      "keyup": _vm.veritySort,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.productInfo, "sort", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productInfo.newPrice),
      expression: "productInfo.newPrice"
    }],
    ref: "price",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.productInfo.newPrice)
    },
    on: {
      "keyup": _vm.verityPrice,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.productInfo, "newPrice", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("必選項目")]), _vm._v(" "), _c('div', {
    staticClass: "h-38 radio text-left",
    staticStyle: {
      "border-left": "1px solid #d2d6de"
    }
  }, [_c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productInfo.is_mandatory),
      expression: "productInfo.is_mandatory"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "productInfoMandatoryRadio"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.productInfo.is_mandatory, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.productInfo, "is_mandatory", 1)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("是")])]), _vm._v(" "), _c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productInfo.is_mandatory),
      expression: "productInfo.is_mandatory"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "productInfoMandatoryRadio"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.productInfo.is_mandatory, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.productInfo, "is_mandatory", 0)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("否")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("預設選取")]), _vm._v(" "), _c('div', {
    staticClass: "h-38 radio text-left",
    staticStyle: {
      "border-left": "1px solid #d2d6de"
    }
  }, [_c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productInfo.is_default),
      expression: "productInfo.is_default"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "defaultRadio"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.productInfo.is_default, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.productInfo, "is_default", 1)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("是")])]), _vm._v(" "), _c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productInfo.is_default),
      expression: "productInfo.is_default"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "defaultRadio"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.productInfo.is_default, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.productInfo, "is_default", 0)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("否")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("選購數量")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productInfo.min_limit),
      expression: "productInfo.min_limit"
    }],
    ref: "minLimit",
    staticClass: "c-auto form-control",
    staticStyle: {
      "width": "calc(50% - 10px)"
    },
    attrs: {
      "placeholder": "0為無上限",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.productInfo.min_limit)
    },
    on: {
      "keyup": _vm.verityMinLimit,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.productInfo, "min_limit", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pull-left",
    staticStyle: {
      "line-height": "38px",
      "width": "20px"
    }
  }, [_vm._v("~")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productInfo.max_limit),
      expression: "productInfo.max_limit"
    }],
    ref: "maxLimit",
    staticClass: "c-auto form-control",
    staticStyle: {
      "width": "calc(50% - 10px)"
    },
    attrs: {
      "placeholder": "0為無上限",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.productInfo.max_limit)
    },
    on: {
      "keyup": _vm.verityMaxLimit,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.productInfo, "max_limit", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.trigger(_vm.option.event)
      }
    }
  }, [_vm._v("\n          確定\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("排"), _c('div', {
    staticClass: "inline-block w-35"
  }), _vm._v("序")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("價"), _c('div', {
    staticClass: "inline-block w-35"
  }), _vm._v("格")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59c262cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/ProductInfoModal.vue
// module id = 2438
// module chunks = 1